import styled from 'styled-components';
import { Colors } from '../../../../../core/CssVariables';

export const SLine = styled.div`
  width: 2px;
  height: 30px;
  background-color: ${Colors.DisabledGrey};
`;
